export type EduzzThemeMode = 'light' | 'dark';

export function applyEduzzThemeAttribute(mode: EduzzThemeMode) {
  if (!document?.body) {
    return;
  }

  document.body.setAttribute('data-eduzz-theme', mode);
}
